import { ref, watch } from 'vue';
import i18n, { syncDocumentLang } from '../plugins/i18n';

function readInitialMarketingLang() {
  try {
    const urlLang = new URLSearchParams(window.location.search).get('lang');
    if (urlLang && ['fr', 'en'].includes(urlLang)) return urlLang;
  } catch (_err) {
    /* ignore */
  }
  try {
    const saved = localStorage.getItem('user-locale') || localStorage.getItem('locale');
    if (saved && ['fr', 'en'].includes(saved)) return saved;
  } catch (_err) {
    /* ignore */
  }
  const browser = (navigator.language || 'en').split('-')[0];
  return ['fr', 'en'].includes(browser) ? browser : 'en';
}

const marketingLang = ref(readInitialMarketingLang());

/** Applique la langue marketing + vue-i18n + localStorage (source unique). */
export function applyMarketingLang(value, { persist = true } = {}) {
  if (!['fr', 'en'].includes(value)) return;
  if (marketingLang.value !== value) {
    marketingLang.value = value;
  }
  try {
    if (persist) {
      localStorage.setItem('user-locale', value);
      localStorage.setItem('locale', value);
    }
  } catch (_err) {
    /* ignore */
  }
  try {
    if (i18n?.global?.locale && i18n.global.locale.value !== value) {
      i18n.global.locale.value = value;
    }
  } catch (_err) {
    /* ignore */
  }
  syncDocumentLang(value);
}

export function useMarketingLang() {
  function setMarketingLang(value) {
    applyMarketingLang(value, { persist: true });
  }

  watch(
    marketingLang,
    (value) => {
      syncDocumentLang(value);
    },
    { immediate: true }
  );

  return {
    lang: marketingLang,
    setMarketingLang,
  };
}
